module.exports = __webpack_public_path__ + "img/yj(1).22962b88.png";